"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
var useDialogTitleClasses_1 = __importDefault(require("./hooks/useDialogTitleClasses"));
var CloseButton_1 = __importDefault(require("./CloseButton"));
var Title_1 = __importDefault(require("./Title"));
var DialogTitle = function (props) {
    var onClose = props.onClose, showCloseButton = props.showCloseButton, children = props.children, classes = props.classes, disableButtonClose = props.disableButtonClose;
    var dialogTitleClasses = (0, useDialogTitleClasses_1.default)(classes, showCloseButton);
    if (!children)
        return null;
    return (react_1.default.createElement(DialogTitle_1.default, { id: "customized-dialog-title", classes: dialogTitleClasses },
        react_1.default.createElement(Title_1.default, null, children),
        react_1.default.createElement(CloseButton_1.default, { disableButtonClose: disableButtonClose, onClose: onClose, showCloseButton: showCloseButton })));
};
exports.default = DialogTitle;
